module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pref-head"
  }, [_c('a', {
    attrs: {
      "id": "pl-7-7"
    }
  }), _c('b', [_vm._v("THE DESIGNER SAYS")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('b', [_c('span', {
    staticClass: "textstyle9"
  }, [_vm._v("I WANT")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle9"
  }, [_vm._v("TO MAKE")]), _vm._v(" BEAUTIFUL THINGS"), _c('span', {
    staticClass: "textstyle9"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle9"
  }, [_vm._v("EVEN IF")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle9"
  }, [_vm._v("NOBODY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle9"
  }, [_vm._v("CARES.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Saul Bass")]), _vm._v(" ( 1920–96 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-8-8"
    }
  }), _vm._v("In hindsight, I think "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("I’ve always")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("been a designer.")]), _vm._v(" I was always inquisitive. Even when I was delivering newspapers I wanted to do it quickly, accurately, and make sure the paper landed on the doorstep in a nice line.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Vince Frost")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-9-9"
    }
  }), _vm._v("I was thrown out of French class for a day because I was in the back of the room drawing a lowercase "), _c('i', [_vm._v("k")]), _vm._v("."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("It was then that I knew I should go to art school.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Tobias Frere-Jones")]), _vm._v(" ( 1970– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-10-10"
    }
  }), _vm._v("At the age of fourteen in Parma, Ohio, I hadn’t the faintest idea of how one would go about getting type set, and so like a lot of us, I became very good at tracing. Then one day my dad happened to visit a trade show where they were giving away free samples of a hot new product, dry transfer lettering. He brought me home a single sheet of Chartpak 36 pt. Helvetica Medium."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("To this day, that typeface at that size and weight has the same effect on me as hearing “Maggie May” by Rod Stewart.")]), _c('br'), _vm._v(" It was what I was yearning for: Magical Instant Real Graphic Design in a Can.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Bierut")]), _vm._v(" ( 1957– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-11-11"
    }
  }), _vm._v("When I first started studying typography, "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("I have to admit I found")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("it tedious.")]), _vm._v(" It wasn’t until I managed to relate it to my own perception of the world that it started to fascinate me.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jonathan Barnbrook")]), _vm._v(" ( 1966– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-12-12"
    }
  }), _vm._v("TYPOGRAPHERS ARE MASONS "), _c('span', {
    staticClass: "textstyle22"
  }, [_vm._v("OF THE PRINTED WORD.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alan Fletcher")]), _vm._v(" ( 1931–2006 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-13-13"
    }
  }), _vm._v("Get acquainted with the shapes of the type letters themselves. They are the units out of which the structure is made—unassembled bricks and beams. "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("Pick good ones and")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("stick to them.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("William Addison Dwiggins")]), _vm._v(" ( 1880–1956 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('a', {
    attrs: {
      "id": "pl-14-14"
    }
  }), _c('span', {
    staticClass: "textstyle26"
  }, [_vm._v("Letters do love")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle26"
  }, [_vm._v("one another.")]), _vm._v(" However, due to their anatomical differences, some letters have a hard time achieving intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ellen Lupton")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-15-15"
    }
  }), _c('b', [_vm._v("A good alphabet is like a harmonious group of people in which "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("no one")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("misbehaves.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jan Tschichold")]), _vm._v(" ( 1902–74 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-16-16"
    }
  }), _c('b', [_c('span', {
    staticClass: "red"
  }, [_vm._v("EVERYTHING HANGS")]), _vm._v(" ON SOMETHING ELSE.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ray Eames")]), _vm._v(" ( 1912–88 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-17-17"
    }
  }), _vm._v("My collages are not jigsaw puzzles, but organisms that grow until their weight balances their energy. What should happen next? Which way does it seem to turn? "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("I search for")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("an internal logic within the work.")]), _vm._v(" That logic may become more complex or turn in on itself. But it is no more random than a twisting vine.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Martin Venezky")]), _vm._v(" ( 1957– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-18-18"
    }
  }), _c('b', [_vm._v("TAKE THINGS AWAY "), _c('span', {
    staticClass: "textstyle36"
  }, [_vm._v("UNTIL YOU CRY.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Frank Chimero")]), _vm._v(" ( 1984 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-19-19"
    }
  }), _vm._v("The nature of process, to one degree or another, involves failure. "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("You have")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("at it. It doesn’t work. You keep pushing. It gets better.")]), _vm._v(" But it’s not good. It gets worse. You go at it again. Then you desperately stab at it, believing “this isn’t going to work.” And it does!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Saul Bass")]), _vm._v(" ( 1920–96 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-20-20"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("We do a lot of groping here.")]), _vm._v(" I don’t think there are answers. "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("I think there")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("are thoughts.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Muriel Cooper")]), _vm._v(" ( 1925–94 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-21-21"
    }
  }), _vm._v("I read once about the concepts of the lateral idea and the vertical idea. If you dig a hole and it’s in the wrong place, digging it deeper isn’t going to help. The lateral idea is when you skip over and "), _c('span', {
    staticClass: "textstyle43"
  }, [_vm._v("dig someplace else.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Seymour Chwast")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-22-22"
    }
  }), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("IT IS IMPORTANT")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("TO USE YOUR HANDS.")]), _c('br'), _vm._v(" THIS IS WHAT DISTINGUISHES YOU FROM A COW OR A COMPUTER OPERATOR.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Paul Rand")]), _vm._v(" ( 1914 –96 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "pl-23-23"
    }
  }), _vm._v("Whether instructed to stroke ten thousand cycles or even just a few hundred, "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("the computer")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("never complains.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("John Maeda")]), _vm._v(" ( 1966– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-24-24"
    }
  }), _vm._v("IT’S THE PLEASURE IN SLOWLY CRAFTING TOGETHER SOMETHING WHICH ONLY YOU WOULD DO. A WHOLE PLAY COULD GO BY ON THE RADIO WHILE YOU DID ONE SIDE OF A NEWS-SHEET, BECAUSE OF ALL THE PASTING-UP AND NICKING-OVER OF LINE-ENDINGS. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("THE SPEED OF IT ON A COMPUTER")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("IS UNAPPEALING.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Richard Hollis")]), _vm._v(" ( 1934 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-25-25"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("The tactile qualities of materials")]), _vm._v(", such as tracing- and colored paper, boards, and overlay film that often were a source of inspiration, are no longer deemed an essential component in developing a design. I first became aware of these changes several years ago, when the art supply store closed my account because I did not purchase enough materials to reach the quarterly minimum charge.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Willi Kunz")]), _vm._v(" ( 1943– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-26-26"
    }
  }), _c('span', {
    staticClass: "textstyle53"
  }, [_c('b', [_vm._v("Make")])]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("your own")])]), _vm._v(" "), _c('span', {
    staticClass: "textstyle53"
  }, [_c('b', [_vm._v("tools")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Bruce Mau")]), _vm._v(" ( 1959– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-27-27"
    }
  }), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("THE BRAIN")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("IS")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("THE MOST DEMOCRATIC TOOL")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("THAT")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("ALL ARTISTS")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("AND DESIGNERS")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("SHARE.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Daniel Eatock")]), _vm._v(" ( 1975– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-28-28"
    }
  }), _vm._v("You approach each project searching for a dozen great ideas, not just one or two. After about seven designs, "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("you realize")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("there really are infinite")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("ways to look at a problem.")]), _vm._v(" I now completely enjoy the process, though I’m keenly aware that all but one of those dozen great ideas will eventually be killed. It’s strangely liberating.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Gail Anderson")]), _vm._v(" ( 1962– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-29-29"
    }
  }), _vm._v("A graphic designer usually makes "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("hundreds of small")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("drawings")]), _vm._v(" and then picks one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Bruno Munari")]), _vm._v(" ( 1907–98 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-30-30"
    }
  }), _c('b', [_vm._v("I HAVE A LOT OF FLAT FILES, BUT I JUST STICK SHIT IN THERE AND "), _c('span', {
    staticClass: "textstyle63"
  }, [_vm._v("NEVER LOOK BACK.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Mike Mills")]), _vm._v(" ( 1966– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-31-31"
    }
  }), _vm._v("I have a bunch of calendars I used before I went digital. Every once in a while, I’ll open up one from 1991 and look at all the names and appointments and things that, at the time, seemed so important. Meetings that I was really worried about, things that I was getting calls four times a day about, and I wonder, “Where did it all go? Where are they now?” It’s so strange, everything has disappeared. "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("The only")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("thing that stays behind is the work.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Bierut")]), _vm._v(" ( 1957– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-32-32"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("The ego is not supposed")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to be involved in graphic design.")]), _c('br'), _vm._v(" But I find that for myself, without exception, the more I deal with the work as something of my own, as something that is personal, the more successful it is as something that’s compelling, interesting, and sustaining.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Marian Bantjes")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-33-33"
    }
  }), _vm._v("I think my work has too much character at times and looks too much like me.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("It’s hard for me to get away from that; "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("it’s hard for me")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to remove myself")]), _vm._v(" unless I just did flush left Helvetica on a white background all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("James Victore")]), _vm._v(" ( 1962– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-34-34"
    }
  }), _c('b', [_vm._v("To suggest that the way we use Helvetica is an easy way out typographically is ridiculous. Simply ridiculous. We spend an enormous amount of time spacing, lining, and positioning type.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('b', [_vm._v("The fact that we use only a small variety of typefaces demands a certain discipline, a skillful precision, a focus on the finer details. "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("It’s")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("certainly not a-different-typeface-")]), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("for-every-occasion attitude. Now,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("that would be an easy way out.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Experimental Jetset:")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Marieke Stolk")]), _vm._v(" ( 1967– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Danny van den Dungen")]), _vm._v(" ( 1971– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erwin Brinkers")]), _vm._v(" ( 1973– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-35-35"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("The more")]), _vm._v(" uninteresting "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("a letter,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("the more")]), _vm._v(" useful "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("it is to the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle40"
  }, [_vm._v("typographer.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Piet Zwart")]), _vm._v(" ( 1885–197 7 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-36-36"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("There are ten, maybe fifteen very good typefaces")]), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("which I can agree")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("with at least.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("There are 30,000")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("on the market,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("of which 29,990")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("can be sunk in")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("the Pacific Ocean")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("without causing")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("any cultural damage.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Kurt Weidemann")]), _vm._v(" ( 1922–2011 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-37-37"
    }
  }), _c('b', [_vm._v("One of the things I have observed, looking back historically, is how elegant a seventeenth-century book looks. One of the reasons it looks so elegant is because of the restrictions: "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("there")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("was only one typeface available")]), _vm._v(", there weren’t that many fonts, and virtually all you could do was play with sizes, italics, and so forth. Automatically it looks elegant by today’s standards.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Colin Forbes")]), _vm._v(" ( 1928– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-38-38"
    }
  }), _c('b', [_vm._v("SOME GET DRUNK FROM A CHEAP BOTTLE OF WINE; "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("SOME GET")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("DRUNK BY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("STUDYING OLD")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("LETTERFORMS.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Hermann Zapf")]), _vm._v(" ( 1918– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-39-39"
    }
  }), _vm._v("I have such a love of typography that I feel like "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("it’s catnip.")]), _vm._v(" I have to be careful that it doesn’t seduce me to the point that I end up resting on the beauty of lettering.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Abbott Miller")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-40-40"
    }
  }), _c('b', [_vm._v("If your words aren’t truthful, the finest optically letter-spaced "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("typography")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("won’t help.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Edward Tufte")]), _vm._v(" ( 1942– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-41-41"
    }
  }), _vm._v("I remember reading that during the Stalin years in Russia that everything labeled veal was actually chicken.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I can’t imagine what everything labeled chicken was. We can accept certain kinds of misrepresentation, such as fudging about the amount of fat in his hamburger, but once a butcher knowingly sells us spoiled meat, we go elsewhere. "), _c('span', {
    staticClass: "textstyle84"
  }, [_vm._v("As a designer, do we have")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle84"
  }, [_vm._v("less responsibility to our public")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle84"
  }, [_vm._v("than a butcher?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Milton Glaser")]), _vm._v(" ( 1929– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-42-42"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("NO ONE LOVES AUTHENTICITY LIKE A GRAPHIC DESIGNER.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle81"
  }, [_vm._v("AND NO ONE IS")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle81"
  }, [_vm._v("QUITE AS GOOD AT")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle81"
  }, [_vm._v("SIMULATING IT.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Bierut")]), _vm._v(" ( 1957– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-43-43"
    }
  }), _vm._v("There’s a fine line between the slickness that modern eyes and modern technology expect and a "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("faux")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("distressed look")]), _vm._v(" caused by making things deliberately wobbly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Matthew Carter")]), _vm._v(" ( 1937– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-44-44"
    }
  }), _vm._v("The trouble with graphic design today is: "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("when")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("can you believe it?")]), _vm._v(" It’s not the message of the designer anymore. Every applied artist ends up selling his or her soul at some point.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I haven’t done it, and look at me. People call me one of the most famous designers in the world, and I haven’t got any money.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Peter Saville")]), _vm._v(" ( 1955– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-45-45"
    }
  }), _vm._v("I suspect what I’m really against is what that term “graphic design” has come to represent, i.e., synonymous with business cards, logos, identities, and advertising, and again, simply put, those are things I’m just not interested in. To me that idea of “graphic design” is as far removed from my interests as being a milkman or a lawyer. In fact, "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("I’d rather be a milkman.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stuart Bailey")]), _vm._v(" ( 1973– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-46-46"
    }
  }), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("The words graphic designer,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("architect, or industrial")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("designer stick in my throat")]), _vm._v(", giving me a sense of limitation, of specialization within the specialty, of a relationship to society and form itself that is unsatisfactory and incomplete. This inadequate set of terms to describe an active life reveals only partially the still undefined nature of the designer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alvin Lustig")]), _vm._v(" ( 1915– 55 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-47-47"
    }
  }), _vm._v("WHAT I DO IS NOT REALLY TYPOGRAPHY, WHICH I THINK OF AS AN ESSENTIALLY MECHANICAL MEANS OF PUTTING CHARACTERS DOWN ON A PAGE. IT’S DESIGNING WITH LETTERS. AARON BURNS CALLED IT “TYPOGRAPHICS,” AND SINCE YOU’VE GOT TO PUT A NAME ON THINGS TO MAKE THEM MEMORABLE, "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("“TYPOGRAPHICS” IS AS GOOD")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("A NAME FOR WHAT I DO AS ANY.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Herb Lubalin")]), _vm._v(" ( 1918–81 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-48-48"
    }
  }), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("Respect for the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("content is an absolute")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("requirement")]), _vm._v(" in our business, whether it is about baked beans, or the future of mankind, or what you will.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ken Garland")]), _vm._v(" ( 1929– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-49-49"
    }
  }), _vm._v("Stellar examples of graphic design, "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("design")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("that changed the way")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("we look at the world")]), _vm._v(", are often found in service of the most mundane content: an ad for ink, cigarettes, sparkplugs, or machinery.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Rock")]), _vm._v(" ( 1959– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-50-50"
    }
  }), _vm._v("It would seem unlikely that a manufacturer of shortlived paperboard boxes could make the slightest cultural impact upon his time. But the facts show that if "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("even the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("humblest product is designed")]), _vm._v(", manufactured, and distributed with a sense of human values and with a taste for quality, the world will recognize the presence of a creative force.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Herbert Bayer")]), _vm._v(" ( 1900–85 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-51-51"
    }
  }), _vm._v("Among the great and elegant design exceptions is a toy produced this year that has swept the country. What is it? A small bouncing ball—"), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("the superball.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Charles Eames")]), _vm._v(" ( 1907–78 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head",
    staticStyle: {
      "font-size": "150%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pl-52-52"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("My work is play.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("And I play when I design.")]), _vm._v(" I even looked it up in the dictionary, to make sure that I actually do that, and the definition of “play,” number one, was “engaging in a childlike activity or endeavor,” and number two was “gambling.” And I realize I do both when I’m designing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Paula Scher")]), _vm._v(" ( 1948– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-53-53"
    }
  }), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("I’D SOONER")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("DO THE SAME")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("ON MONDAY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("OR WEDNESDAY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("AS I DO ON")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("A SATURDAY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("OR SUNDAY.")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("I DON’T DIVIDE MY LIFE BETWEEN LABOR AND PLEASURE.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alan Fletcher")]), _vm._v(" ( 1931–2006 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-54-54"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("If at all possible,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("don’t be the designer")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("and the one who")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("chases the money.")]), _vm._v(" It’s very difficult not to get emotional if some bastard isn’t paying on time for the beautiful job you have made.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Tony Brook")]), _vm._v(" ( 1962– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-55-55"
    }
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("DON’T WORRY ABOUT MONEY")]), _vm._v(", "), _c('span', {
    staticClass: "textstyle108"
  }, [_vm._v("DEAL")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle108"
  }, [_vm._v("WITH")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle108"
  }, [_vm._v("MONEY.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Mike Monteiro")]), _vm._v(" ( 1967– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-56-56"
    }
  }), _vm._v("To make a living as a freelance designer— believe me—you have to work hard with your mind and with your hand. For you want to earn at least enough money to dress your beloved wife nicely, to feed your children every day, and "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to live in a house where")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("the rain does not drop")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("on your drawing pad.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Hermann Zapf")]), _vm._v(" ( 1918– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-57-57"
    }
  }), _vm._v("I’m not a big spender. "), _c('span', {
    staticClass: "textstyle112"
  }, [_vm._v("I use")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle112"
  }, [_vm._v("every paper twice.")]), _vm._v(" I use these yellow memos: I write them not on one side—two sides— and in different colors, to use them to the utmost.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Irma Boom")]), _vm._v(" ( 1960– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-58-58"
    }
  }), _vm._v("TO SELL WORK I COULD BE PROUD OF, I’VE HAD TO RANT, RAVE, THREATEN, SHOVE, PUSH, CAJOLE, PERSUADE, WHEEDLE, EXAGGERATE, FLATTER, MANIPULATE, BE OBNOXIOUS, BE LOUD, OCCASIONALLY LIE, AND "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("ALWAYS SELL,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_c('i', [_vm._v("PASSIONATELY")])]), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("George Lois")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-59-59"
    }
  }), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("My greatest fear")]), _vm._v(" is that someone will realize that they shouldn’t be paying attention to that woman behind the curtain... that someone will realize that I’m a sham.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Bonnie Siegler")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-60-60"
    }
  }), _c('b', [_vm._v("There isn’t a color I wouldn’t use, except "), _c('span', {
    staticClass: "textstyle63"
  }, [_vm._v("chartreuse.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Seymour Chwast")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-61-61"
    }
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("IF I DON’T KNOW WHAT TO DO, I USE")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle35"
  }, [_vm._v("BLUE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Wim Crouwel")]), _vm._v(" ( 1928– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-62-62"
    }
  }), _vm._v("I can say that growing up in the ’60s exposed me to how color could be used as a primary design element. Yet surprisingly, "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("I always investigate")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("if the solution could be")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("clearly communicated")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("in black and white.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jennifer Morla")]), _vm._v(" ( 1955– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-63-63"
    }
  }), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("Black letter, black leather,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("black lingerie, black marks,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("black tie, the black box,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("black robes, the black frame")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("that turns white paper")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("into an obituary:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("the depth of black takes each situation and makes it more so.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Lorraine Wild")]), _vm._v(" ( 1953– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-64-64"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("There is no other color that is better than black.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("There are many others")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("that are appropriate")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("and happy, but those")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("colors belong on flowers.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Massimo Vignelli")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('a', {
    attrs: {
      "id": "pl-65-65"
    }
  }), _c('b', [_vm._v("The fact that you can create a third color out of two is something that never ceases to excite me. It’s nothing less than "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("a miracle")]), _c('span', {
    staticClass: "textstyle129"
  }, [_vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Karel Martens")]), _vm._v(" ( 1939– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-66-66"
    }
  }), _c('b', [_vm._v("I did the bloody thing "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("[")]), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle112"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "",
      "height": "45",
      "src": "images/heart.jpg",
      "width": "60"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("NY")]), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("]")]), _vm._v(" in 1975, and I thought it would last a couple of months as a promotion and disappear.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Milton Glaser")]), _vm._v(" ( 1929– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-67-67"
    }
  }), _vm._v("We always take the long view in designing a logo so that it is contemporary enough to reflect its moment yet not so trendy as to appear dated before its time. As the saying goes, "), _c('span', {
    staticClass: "red"
  }, [_vm._v("“Nothing dulls faster than the cutting edge.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Steff Geissbuhler")]), _vm._v(" ( 1942– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-68-68"
    }
  }), _vm._v("I was giving a lecture at the ICA and talking about attention-grabbers and “the trouble with advertising” and other sorts of things, and I said, “Some attention-grabbers are irresistible, like this one, for example,” and "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("I took out a fake pistol and fired it.")]), _vm._v(" It’s something I would never do now! This was back in 1964 or ’65, and I think it was a stupid idea and I would never do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ken Garland")]), _vm._v(" ( 1929– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-69-69"
    }
  }), _vm._v("When Albers gave a lecture, he’d invariably trip over himself as he approached the lectern. He’d also drop his notes. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("Immediate audience")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("sympathy.")]), _vm._v(" I saw him do this at least half a dozen times in nine months. Coincidence?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alan Fletcher")]), _vm._v(" ( 1931–2006 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-70-70"
    }
  }), _vm._v("I try to staff our studio with people who have curiosity and passion. "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("And you must keep a constant lookout")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("for who you might want to hire next,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("because often the curiosity of our")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("team leads them on to other things.")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("You can’t keep brilliance; you let it shine, and then you have to let it go.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stephen Doyle")]), _vm._v(" ( 1956– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-71-71"
    }
  }), _c('span', {
    staticClass: "textstyle43"
  }, [_vm._v("EXTOL YOUR")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle43"
  }, [_vm._v("MENTORS....")]), _c('br'), _vm._v(" THREE PEOPLE RECOGNIZED MY TALENT AND LED ME TO WHAT I DO TODAY. I SPEAK ABOUT THEM OFTEN IN MY LECTURES, AND IN MY BOOKS.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("George Lois")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-72-72"
    }
  }), _vm._v("Having been working now for over fifty years, I can count the good clients on two or three hands. Why they’re good is a magical thing: It has to do with wanting to participate in something they don’t really understand. Most people are blind. And "), _c('span', {
    staticClass: "red"
  }, [_vm._v("to be simultaneously very smart and blind— and to recognize it— takes a rare person.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ivan Chermayeff")]), _vm._v(" ( 1932– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-73-73"
    }
  }), _vm._v("If a client comes to you and says that they’re not really sure what to do, that’s one of the best relationships you can possibly have— when "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("there’s an")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("acknowledgment")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("of a goal but the path")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to the end product")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("is unknown")]), _vm._v(", and they’re open to the collaboration.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Abbott Miller")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('a', {
    attrs: {
      "id": "pl-74-74"
    }
  }), _c('b', [_vm._v("I AM INTERESTED IN IMPERFECTIONS,"), _c('br'), _vm._v(" QUIRKINESS,"), _c('br'), _vm._v(" INSANITY,"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("UNPREDICTABILITY.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Tibor Kalman")]), _vm._v(" ( 1949–99 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-75-75"
    }
  }), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("Sometimes things are")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("beautiful because they work;")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("and sometimes in trying")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("to make things work, you")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("make something beautiful.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("Both approaches are")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("interesting, but aesthetics")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle11"
  }, [_vm._v("are not our priority.")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("You might say we’re interested in the form of side effects.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dexter Sinister:")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("David Reinfurt")]), _vm._v(" ( 1971– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stuart Bailey")]), _vm._v(" ( 1973– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-76-76"
    }
  }), _vm._v("If there is something in common about my books, it is the roughness; they are all unrefined. "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("Very often there is")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("something wrong with them.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Irma Boom")]), _vm._v(" ( 1960– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "pl-77-77"
    }
  }), _c('span', {
    staticClass: "textstyle147"
  }, [_c('b', [_vm._v("I LIKE")])]), _vm._v(" "), _c('span', {
    staticClass: "textstyle147"
  }, [_c('b', [_vm._v("UGLY")])]), _c('b', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("RAW WORK.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Barbara deWilde")]), _vm._v(" ( 1962– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-78-78"
    }
  }), _vm._v("My M.O. became about trying stuff and not worrying about the grid or the structure until I have a feeling for what I’m doing. Then you tidy it up after."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("If you start off tidy, it’s really hard to get messy.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("April Greiman")]), _vm._v(" ( 1948– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-79-79"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("Once you’ve")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("mastered")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("the rules, you")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("can do anything,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("even abolish")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle151"
  }, [_vm._v("them, but")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("without structure it’s impossible to get started.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ed Fella")]), _vm._v(" ( 1938– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-80-80"
    }
  }), _vm._v("THE PAGE GRID IS THE BASIC SKELETON FROM WHICH YOU HANG EVERYTHING. IT’S EQUIVALENT TO THE SCAFFOLDING, OR THE WALLS AND THE JOISTS OF A BUILDING. "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("A GRID IS CRUCIAL.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Neville Brody")]), _vm._v(" ( 1957– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-81-81"
    }
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("The grid system is an aid,")]), _vm._v(" not a guarantee.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Josef Müller-Brockmann "), _c('span', {
    staticClass: "textstyle4"
  }, [_vm._v("( 1914 –96 )")])]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-82-82"
    }
  }), _vm._v("We use grids in our work, but we think we use them in a completely different way than, for example, Swiss late-modernist designers, such as Josef Müller-Brockmann. Although we really admire griddriven work, "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("we wouldn’t dare to")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("call ourselves proper gridniks.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Experimental Jetset:")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Marieke Stolk")]), _vm._v(" ( 1967– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Danny van den Dungen")]), _vm._v(" ( 1971– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erwin Brinkers")]), _vm._v(" ( 1973– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "pl-83-83"
    }
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("I AM A REAL")]), _vm._v(" GRIDNIK.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Wim Crouwel")]), _vm._v(" ( 1928– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-84-84"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("I HATE MESSY OFFICES.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I WANT CLEAN TOI LETS.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I WON’T HAVE POSTERS ALL OVER THE PLACE. I WON’T HAVE CRAPPY NOTICES NEXT TO THE TOI LETS; THAT ANNOYS ME. WE DON’T PRINT OUT STUFF IN COMIC SANS, AND EVEN OUR OFFICE PEOPLE IN BERLIN KNOW THAT WHEN THEY PRINT OUT A NOTICE, THEY MUST USE OUR STUDIO TYPEFACE.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erik Spiekermann")]), _vm._v(" ( 1947– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-85-85"
    }
  }), _vm._v("I love my studio. It is located above a Dunkin’ Donuts in an old neglected four-story building at 14th Street and 6th Avenue in Manhattan. It’s relatively cheap by New York standards, which allows me more latitude in the work I’m doing. "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("It’s a dump,")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("but it’s my dump.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Paul Sahre")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-86-86"
    }
  }), _c('b', [_vm._v("OUR STUDIO IS LIKE A DESIGN LABORATORY, AND "), _c('span', {
    staticClass: "textstyle112"
  }, [_vm._v("EVERYONE")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle112"
  }, [_vm._v("IS TRYING TO")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle112"
  }, [_vm._v("PROVE A THEORY")]), _vm._v(", OR EXERCISE AN EQUATION.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stephen Doyle")]), _vm._v(" ( 1956– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-87-87"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_vm._v("MY DREAM IS TO HAVE PEOPLE WORKING ON")]), _vm._v(" USELESS PROJECTS. "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("THESE HAVE THE GERM OF NEW CONCEPTS.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Charles Eames")]), _vm._v(" ( 1907–78 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-88-88"
    }
  }), _vm._v("Hire people for "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("what")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("they can")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("teach you")]), _vm._v(", not for what you can teach them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Rob Giampietro")]), _vm._v(" ( 1978– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-89-89"
    }
  }), _vm._v("I’ve had many truly talented designers on my staff because I know "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("I am only as good as the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("designers I work with")]), _vm._v(", so I see the hiring component as the most important part of my job"), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Janet Froelich")]), _vm._v(" ( 1946– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-90-90"
    }
  }), _vm._v("My first job was as a "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("cleavage retoucher.")]), _vm._v(" There was an office meeting about stopping Howard Hughes from showing voluptuous parts of the human body, so I was responsible for taking away the cleavage, not putting it in as they do today.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ed Benguiat")]), _vm._v(" ( 1927– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-91-91"
    }
  }), _c('span', {
    staticClass: "textstyle13"
  }, [_vm._v("YOU HAVE TO MAKE")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("THE TIME YOU SPEND DOING SOMETHING")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle13"
  }, [_vm._v("AS INTERESTING")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle13"
  }, [_vm._v("AND AS CONSIDERED")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle13"
  }, [_vm._v("AS THE THING ITSELF.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dexter Sinister:")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("David Reinfurt")]), _vm._v(" ( 1971– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stuart Bailey")]), _vm._v(" ( 1973– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-92-92"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("No one ever built or")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("ruined a career on any")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("piece of work.")]), _vm._v(" In the scheme of things, one’s failures or successes, for that matter, don’t count for a hell of a lot. A sustained body of failures or successes is another matter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Louis Danziger")]), _vm._v(" ( 1923– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-93-93"
    }
  }), _vm._v("When a project fails, we take as our starting point the principle that it’s a conversation that didn’t work out the way it should have, but that doesn’t change anything from the fact that "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("we made an effort to")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("serve an idea we believed in.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Amzalag")]), _vm._v(" ( 1968– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-94-94"
    }
  }), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("I’M OFTEN ASKED FOR")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("ADVICE ON HOW TO BECOME A BETTER GRAPHIC DESIGNER,")]), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("AND THIS IS MY RESPONSE:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("“TWO THINGS—LEARN HOW TO DO CROSSWORD PUZZLES, AND LEARN HOW TO WRITE.”")])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Chip Kidd")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('a', {
    attrs: {
      "id": "pl-95-95"
    }
  }), _c('b', [_vm._v("READ.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("TRAVEL.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("READ.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("ASK.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("READ.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("LEARN.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("READ.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("CONNECT.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('b', [_vm._v("READ.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erik Spiekermann")]), _vm._v(" ( 1947– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-96-96"
    }
  }), _vm._v("The good thing about package design is that research is easy—just go into any supermarket or, better yet, any specialty food store. "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("These are my museums.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Louise Fili")]), _vm._v(" ( 1951– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-97-97"
    }
  }), _vm._v("THROUGH VISITS TO MUSEUMS/SITES/ INSTITUTIONS, READING, RESEARCH, SKETCHING, NOTE TAKING, PHOTO TAKING, AND A GENERAL THREE-WEEK IMMERSION, "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("I FIND MY WAY TO A STORY.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Maira Kalman")]), _vm._v(" ( 1949– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-98-98"
    }
  }), _vm._v("I write to figure out what I can’t make in the studio; I make work in the studio to try to figure out how to engage bigger ideas about design—the ones I can’t quite reach in my writing or get to so directly. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("And")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("when")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("all else fails, I have")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("a painting studio in my")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("basement that is")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("my true sanctuary.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jessica Helfand")]), _vm._v(" ( 1960– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-99-99"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("Writing is torture for me")]), _vm._v(", but I’ve forced myself to do it anyway. I felt that it was the best vehicle I had to try to record the experiences I have had as a designer during what I knew were remarkable times. And I knew from my design history research that some of the rarest documents are those of designers speaking in the first person.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Lorraine Wild")]), _vm._v(" ( 1953– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-100-100"
    }
  }), _vm._v("JUST WHAT IS A BOOK, "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("ANYMORE, ANYWAY?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Craig Mod")]), _vm._v(" ( 1980– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-101-101"
    }
  }), _c('b', [_vm._v("THE NEW BOOK DEMANDS THE NEW WRITER. "), _c('span', {
    staticClass: "textstyle186"
  }, [_vm._v("INKPOT AND")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle186"
  }, [_vm._v("QUILL-PEN ARE DEAD.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("El Lissitzky")]), _vm._v(" ( 1890–1941 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-102-102"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("I DESIGN")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("LIKE A")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("WRITER")]), _vm._v(" AND WRITE LIKE A DESIGNER.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Abbott Miller")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-103-103"
    }
  }), _vm._v("Designers also trade in storytelling. The elements we must master are not the content narratives but the devices of the telling: typography, line, form, color, contrast, scale, weight, etc. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("We speak through our assignment, literally between the lines.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Michael Rock")]), _vm._v(" ( 1959– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-104-104"
    }
  }), _c('b', [_vm._v("Spacing is vital but should be "), _c('span', {
    staticClass: "textstyle192"
  }, [_vm._v("discrete")]), _vm._v(" to the point of imperceptibility.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Otl Aicher")]), _vm._v(" ( 1922–91 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-105-105"
    }
  }), _vm._v("Not everyone recognizes the importance of inner forms, the shape of the negative white spaces within the letter. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("A perfect letter always")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("shows beautiful inner spaces.")]), _vm._v(" These must be as uncluttered, simple, and noble as the movement and silhouette of the black shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jan Tschichold")]), _vm._v(" ( 1902–74 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-106-106"
    }
  }), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("Letters are")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("peculiar things")]), _vm._v(", and readers can take quite a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("It is possible to create shapes that are individually unrecognizable as letters but that are readable when put in context.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erik van Blokland")]), _vm._v(" ( 1967– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-107-107"
    }
  }), _vm._v("The thing that fascinated me about Blackletter forms was the similarity of shapes: "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("the characters would only differ")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("very slightly, yet they would")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("make up all of the meanings")]), _vm._v(", tones, and variations in language. It was amazing that out of this morass of vertical lines, you could read meaningful text.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Jonathan Barnbrook")]), _vm._v(" ( 1966– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "pl-108-108"
    }
  }), _vm._v("The twenty-six letters have been part of our memory since early childhood.")]), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_vm._v("By themselves, however, letters lack meaning and are incapable of transmitting information. Combined into a word, "), _c('span', {
    staticClass: "red"
  }, [_vm._v("a series of letters")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("can be very powerful, more")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("precise than a picture.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Willi Kunz")]), _vm._v(" ( 1943– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('a', {
    attrs: {
      "id": "pl-109-109"
    }
  }), _vm._v("I THINK THE REVOLUTION IN TYPOGRAPHY HAS BEEN IN TERMS OF IMAGE. "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("THE PICTURE")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("AND THE WORD")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("HAVE BECOME")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("ONE THING.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Robert Brownjohn")]), _vm._v(" ( 1925–70 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-110-110"
    }
  }), _vm._v("The story of how I decided to become an artist is this: When I was a very little boy, a cousin of mine came to my house with a paper bag. He asked me if I wanted to see a bird. I thought he had a bird in the bag. He stuck his hand in the bag, and I realized that he had drawn a bird on the side of a bag with a pencil. I was astonished! I perceived this as being miraculous. At that moment, I decided that was what I was going to do with my life. "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("Create miracles.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Milton Glaser")]), _vm._v(" ( 1929– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-111-111"
    }
  }), _vm._v("Where I grew up, I always say that the only time I ever heard the word "), _c('span', {
    staticClass: "textstyle25"
  }, [_c('i', [_vm._v("art")])]), _vm._v(" was if you were talking about somebody named Arthur.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Charley Harper")]), _vm._v(" ( 1922–2007 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-112-112"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("As far back as I can")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("remember, I loved to make")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("things.")]), _vm._v(" I made my own coloring books, I made my own paper dolls, I made dioramas, and I even tried to make my own perfume by crushing rose petals into baby oil....I even handmade an entire magazine when I was twelve with my best friend. Her name was Debbie also, and we named the magazine "), _c('i', [_vm._v("Debutante")]), _vm._v(". We were very proud of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Debbie Millman")]), _vm._v(" ( 1961– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-113-113"
    }
  }), _vm._v("I DON’T KNOW EXACTLY WHEN MY LOVE FOR CHARTS BEGAN. I HAVE A CHERISHED BOOK FROM MY CHILDHOOD CALLED "), _c('i', [_vm._v("COMPARISONS")]), _vm._v(" THAT HOLDS HUNDREDS OF PAGES OF CHARTS AND MEASUREMENTS AND LISTS OF DATA ABOUT THE "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("FASTEST CARS AND TALLEST")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("WATERFALLS AND LARGEST")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("ANIMALS")]), _vm._v(", WHICH DEFINITELY EXERTED AN INFLUENCE ON ME.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Nicholas Felton")]), _vm._v(" ( 197 7– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-114-114"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("IMITATE.")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("DON’T BE SHY ABOUT IT. TRY TO GET AS CLOSE AS YOU CAN. YOU’LL NEVER GET ALL THE WAY, AND THE SEPARATION MIGHT BE TRULY REMARKABLE.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Bruce Mau")]), _vm._v(" ( 1959– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-115-115"
    }
  }), _vm._v("I don’t really look at other people’s work....On the whole I’m influenced by other things— by painters or signs in the street. The way people write “On Sale Now” in shop windows attracts me more than the most serious design. It’s not that I don’t find anyone good. But I think "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("it’s dangerous")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to get close to someone else’s")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("work and swallow it.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Fabien Baron")]), _vm._v(" ( 1959– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-116-116"
    }
  }), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("I’ve been described as not")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("having any recognizable style")]), _vm._v(" and that’s one of the greatest compliments I could hope for.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I want each book to have as much of its own individual personality as possible, based on what it is and what it’s about.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Chip Kidd")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-117-117"
    }
  }), _c('b', [_vm._v("I’VE ALWAYS BEEN MORE INTERESTED IN ATTRACTING "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("ATTENTION")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("TO THE PAGE")]), _vm._v(" THAN BRINGING ATTENTION TO MYSELF.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ruth Ansel")]), _vm._v(" ( 1938– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-118-118"
    }
  }), _vm._v("The “coffee-table” book is little more than an extended color-supplement.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("Such books—large, thick, squarish, and trendy, printed a soupy offset, plastic-covered, and lavish with art photography— "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("such books are a menace")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("to design students.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Norman Potter")]), _vm._v(" ( 1923–95 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-119-119"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("MOST BIG BOOKS ARE")])]), _vm._v(" "), _c('b', [_vm._v("CRAP.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stefan Sagmeister")]), _vm._v(" ( 1962– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-120-120"
    }
  }), _vm._v("THE PRINTED SURFACE, THE INFINITY OF BOOKS, MUST BE TRANSCENDED. "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("THE ELECTRO-")]), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("LIBRARY.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("El Lissitzky")]), _vm._v(" ( 1890–1941 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "pl-121-121"
    }
  }), _vm._v("The prospect of change brought about by the swift flow of information has now become so great that "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("we cannot")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle105"
  }, [_vm._v("find a point to rest")]), _vm._v("— we’re not given a still picture to contemplate at leisure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Quentin Fiore")]), _vm._v(" ( 1920– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "textstyle17"
  }, [_c('a', {
    attrs: {
      "id": "pl-122-122"
    }
  }), _vm._v("I can concentrate anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I have a busy open plan studio with twenty-six people constantly grabbing me for involvement in projects, meetings, etc. I have three small children who wake up in the middle of the night and do the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Vince Frost")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-123-123"
    }
  }), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("I think a good place")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("to design is in the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("cab returning from a")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("meeting.")]), _vm._v(" You’re infused with the problem, and there’s no interference or telephones ringing, and you don’t have to talk to the driver. You can just think. or twenty minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("It’s a very intense fifteen")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ivan Chermayeff")]), _vm._v(" ( 1932– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-124-124"
    }
  }), _vm._v("BY LIVING AND WORKING IN THE COUNTRY, I FELT I COULD ENJOY A MORE INTEGRATED LIFE, AND ALTHOUGH I STILL NEED THE PERIODIC STIMULATION OF NEW YORK CITY, THE OPPORTUNITY AND CREATIVE ACTIVITY IN AN AREA OF BOTH BEAUTY AND TRANQUILITY SEEMED TO ME TO FAR EXCEED ANYTHING THAT A STUDIO AND RESIDENCE IN NEW YORK MIGHT OFFER—"), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("THE WAY A MAN LIVES")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("IS ESSENTIAL TO THE WORK HE PRODUCES.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("THE TWO CANNOT BE SEPARATED.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Lester Beall")]), _vm._v(" ( 1903–69 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('a', {
    attrs: {
      "id": "pl-125-125"
    }
  }), _c('b', [_vm._v("Our working and home lives are fully integrated. "), _c('span', {
    staticClass: "textstyle17"
  }, [_vm._v("There’s no time clock to punch")]), _vm._v(" after we climb the two flights of stairs in the morning to the top floor of our house where our offices are. We may be working while the laundry is spinning. Zuzana may be busy with some tricky kerning issues while she has a cake in the oven. The work we create, our photos and ceramics, are all over our house. I often have a basketball game on in the evening while I’m working on my type specimen booklets.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Rudy VanderLans")]), _vm._v(" ( 1955– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-126-126"
    }
  }), _vm._v("In the right hands, technical constraints turn into celebrations of simplicity, and awkward alphabets are typographic heroes for the day. "), _c('span', {
    staticClass: "textstyle48"
  }, [_vm._v("There is no bad type.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Erik Spiekermann")]), _vm._v(" ( 1947– )")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("E. M. Ginger")]), _vm._v(" ( 1948– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-127-127"
    }
  }), _c('b', [_vm._v("I have a fantasy in which I become "), _c('span', {
    staticClass: "textstyle41"
  }, [_vm._v("Type Czar of the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle41"
  }, [_vm._v("World")]), _vm._v(" and eradicate all the bad ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Seymour Chwast")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-128-128"
    }
  }), _vm._v("God protect us from the "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("vagrant")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("creativity")]), _vm._v(" of the typomaniacs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Kurt Weidemann")]), _vm._v(" ( 1922–2011 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "pl-129-129"
    }
  }), _c('b', [_c('span', {
    staticClass: "textstyle229"
  }, [_vm._v("I AM")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle230"
  }, [_vm._v("TYPE!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('b', [_vm._v("Frederic Goudy ( 1865–1947 )")])]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-130-130"
    }
  }), _c('b', [_c('span', {
    staticClass: "red"
  }, [_vm._v("Every typeface wants to know: “Do I look fat in this paragraph?”")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("It’s all")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("a matter of context. A font")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("could look perfectly sleek")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("on screen, yet appear")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("bulky and out of shape in")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("print. Mrs. Eaves has a")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle42"
  }, [_vm._v("low waist and a small body.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ellen Lupton")]), _vm._v(" ( 1963– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-131-131"
    }
  }), _vm._v("Neither Garamond nor Caslon nor Baskerville ever possessed a bold version before their twentieth-century revival. They were designed and cut in roman and italic only. To use them for modern publicity, in large sizes and set to wide measures, can be brutal. "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("To enlarge")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("Garamond beyond the largest size cast")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("in metal destroys its intimacy.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Emil Ruder")]), _vm._v(" ( 1914 –70 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-132-132"
    }
  }), _vm._v("IN ANCIENT TIMES CAPITAL LETTERS (THE ONLY LETTERS IN USE THEN) WERE DRAWN WITH A SLATE PENCIL OR WERE INCISED WITH A CHISEL. "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("THEIR FORM WAS INTIMATELY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("ASSOCIATED WITH THESE TOOLS.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Herbert Bayer")]), _vm._v(" ( 1900–85 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-133-133"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("Handmade engraving")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("and printing are things of")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("the past")]), _vm._v(", and while they have not yet become anachronisms, their proper place should be on the dusty shelves of snobbish collectors.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alexey Brodovitch")]), _vm._v(" ( 1898–1971 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-134-134"
    }
  }), _c('b', [_vm._v("I often battle with the paper. "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("While I could")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("never work with")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("a crow quill, a")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("Speedball pen")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("or Rapidograph")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("enables me to")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("bear down on")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle20"
  }, [_vm._v("the paper.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Seymour Chwast")]), _vm._v(" ( 1931– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-135-135"
    }
  }), _vm._v("The most beautiful thing is a "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("blank")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("sheet of paper")]), _vm._v(" before you put a pencil or pen to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ed Benguiat")]), _vm._v(" ( 1927– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-136-136"
    }
  }), _vm._v("I don’t launch a message at my viewers but instead "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("provide an empty vessel.")])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("In turn, I expect them to deposit something there, their own messages or images. This is an important aspect of communication, accepting what the other has to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Kenya Hara")]), _vm._v(" ( 1958– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-137-137"
    }
  }), _vm._v("Design is a way of looking at the world. You produce an artifact or create a system with a set of conditions, an infrastructure or an apparatus where you’ve done half the equation and you "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("leave")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("the rest for whoever")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("wants to participate.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Lucille Tenazas")]), _vm._v(" ( 1953– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-138-138"
    }
  }), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("Designers have always")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("wanted to change the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("world")]), _vm._v("—it’s hardwired in our DNA. Maybe it’s time to collectively organize our efforts to really begin to make those contributions. In the meantime, our little enterprise will continue just for the joy of the effort.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("William Drenttel")]), _vm._v(" ( 1953– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-139-139"
    }
  }), _vm._v("MY WORK CONTINUES TO BE CENTERED ON MAKING A PLACE FOR WHO AND WHAT IS LEFT OUT, LISTENING TO THE OTHER PERSON, AND BEING "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("NOT ONLY")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("RECEPTIVE TO CHANGE")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("BUT")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle15"
  }, [_vm._v("INITIATING CHANGE.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sheila Levrant de Bretteville "), _c('span', {
    staticClass: "textstyle4"
  }, [_vm._v("( 1940– )")])]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-140-140"
    }
  }), _c('b', [_vm._v("I’m trying to find a way of working which "), _c('span', {
    staticClass: "textstyle246"
  }, [_vm._v("reduces")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle246"
  }, [_vm._v("the number")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle246"
  }, [_vm._v("of layers")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle246"
  }, [_vm._v("of assholes")]), _vm._v(" between me and the public.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Tibor Kalman")]), _vm._v(" ( 1949–99 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "pl-141-141"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("MOST PEOPLE HAVE")])]), _vm._v(" "), _c('span', {
    staticClass: "textstyle165"
  }, [_c('b', [_vm._v("SOMETHING")])]), _vm._v(" "), _c('span', {
    staticClass: "textstyle165"
  }, [_c('b', [_vm._v("POSITIVE TO")])]), _vm._v(" "), _c('span', {
    staticClass: "textstyle165"
  }, [_c('b', [_vm._v("OFFER")])]), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v(", EVEN IF IT IS TOTAL RESISTANCE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Andrew Blauvelt")]), _vm._v(" ( 1964 – )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "id": "pl-142-142"
    }
  }), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("Having a husband")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("as your client")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle25"
  }, [_vm._v("is pretty easy.")]), _vm._v(" You never show them what you’re doing until late at night. They’re exhausted, and they say, “I like it!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Elaine Lustig Cohen")]), _vm._v(" ( 1927– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-143-143"
    }
  }), _vm._v("It’s a total collaboration.... We do everything together, so we’re in a lock-step throughout the process. She’s remarkable. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("What can I tell")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("you? I love the lady.")]), _vm._v(" I love her for who she is, and I love her for what she does.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Saul Bass")]), _vm._v(" ( 1920–96 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "pl-144-144"
    }
  }), _vm._v("I TRY NOT TO HAVE A STYLE, ALTHOUGH I HAVE ONE! THAT’S WHY "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("COLLABORATION")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle56"
  }, [_vm._v("IS IMPORTANT.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Sara De Bondt")]), _vm._v(" ( 197 7– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-145-145"
    }
  }), _vm._v("As a graphic designer,")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I like collaboration.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I don’t want to be in a cold garret somewhere smoking unfiltered Camels all by myself with paint all over my body—because")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("I like sheets too much.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Carin Goldberg")]), _vm._v(" ( 1953– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-146-146"
    }
  }), _c('b', [_vm._v("Every once in a great while I think I might like to "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("go back")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle82"
  }, [_vm._v("to painting.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Janet Froelich")]), _vm._v(" ( 1946– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-147-147"
    }
  }), _c('b', [_vm._v("I NEVER GAVE UP PAINTING, "), _c('span', {
    staticClass: "textstyle10"
  }, [_vm._v("I JUST")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle10"
  }, [_vm._v("CHANGED")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle10"
  }, [_vm._v("MY PALETTE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Ray Eames")]), _vm._v(" ( 1912–88 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-148-148"
    }
  }), _vm._v("I’m fifty-one years of age now! People still phone and ask me if I want to design album covers. They tell me I can do whatever I want, but it’s very difficult for me to explain that the rack of a record store is not where I wish to express myself. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("Go ask")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("a twenty-year-old.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Peter Saville")]), _vm._v(" ( 1955– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-149-149"
    }
  }), _vm._v("YOU CAN’T DO THE SAME THING FOR FIVE YEARS. YOU HAVE TO GET RID")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("OF IT. IT DOESN’T MATTER ANYMORE. JUST LET IT GO, EVEN IF IT’S YOUR SIGNATURE. EVEN IF EVERYBODY EXPECTS YOU TO DO IT. "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("TRY TO FIND")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle12"
  }, [_vm._v("ANOTHER WAY TO WALK.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Paula Scher")]), _vm._v(" ( 1948– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "pl-150-150"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("Little by little, I introduced change to every aspect of jacket design.")])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("I rejected traditional Pantone colors, opting to use paint chips from hardware stores—to the consternation of my printers. I also cut deals with the production department, like trading an extra color for an unusual paper stock. Book buyers began to take notice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Louise Fili")]), _vm._v(" ( 1951– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('a', {
    attrs: {
      "id": "pl-151-151"
    }
  }), _vm._v("Every time I am told that something “must” be done in such and such a way, I eventually find out that the "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("“must”")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("doesn’t hold quite the")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle30"
  }, [_vm._v("weight it’s meant to.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Alvin Lustig")]), _vm._v(" ( 1915– 55 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheada"
  }, [_c('a', {
    attrs: {
      "id": "pl-152-152"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("Somehow I am always over my head, or underwater, or inexpert at what I am asked to do. It is thrilling.")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("This is what keeps me")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("coming into the studio every")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("day. You just never know")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("who is going to call and what")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("obstacle they are going")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle55"
  }, [_vm._v("to throw in your path.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Stephen Doyle")]), _vm._v(" ( 1956– )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "heada"
  }, [_c('a', {
    attrs: {
      "id": "pl-153-153"
    }
  }), _vm._v("What counts is the present. And that is humbling because no matter how much experience you have, "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("the blank page is still")]), _vm._v(" "), _c('span', {
    staticClass: "textstyle39"
  }, [_vm._v("terrifying....")]), _vm._v("There’s fun, anxiety, and concern. But in the end, it’s so wonderful when you do make it happen. You live in a sort of threatened state, and then it’s delicious when you get out of the danger zone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Saul Bass")]), _vm._v(" ( 1920–96 )")]), _vm._v(" "), _c('p', {
    staticClass: "page"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "pl-154-154"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("I am already at work on the")])]), _vm._v(" "), _c('b', [_vm._v("type of the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "textstyle3"
  }, [_vm._v("Lucian Bernhard")]), _vm._v(" ( 1883–1972 )")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79eba95f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chaptertitle1.vue
// module id = 72
// module chunks = 0